import React, { FC } from 'react';

import { Box, Flex, Heading, Link } from '@rover/kibble/core';
import useFooterShim from '@rover/shared/js/hooks/useFooterShim';

import { renderFooterItemsAsChunk } from './utils';

const LearnMore: FC = () => {
  const { footer } = useFooterShim();
  const { learnMore, helpLinks } = footer || {};

  if (!learnMore?.visible || !helpLinks?.items) return null;
  const [helpLink] = helpLinks.items;

  return (
    <Box maxWidth={['none', '30%']}>
      <Heading size="300" my="6x" as="div">
        {learnMore.name}
      </Heading>
      <Flex>
        {renderFooterItemsAsChunk(learnMore.items, 4, [
          <Box key="helpLink" display={['block', 'none']}>
            <Link
              key={helpLink.name}
              href={helpLink.url}
              variant="secondary"
              size="100"
              underline={false}
            >
              {helpLink.name}
            </Link>
          </Box>,
        ])}
      </Flex>
    </Box>
  );
};

export default LearnMore;
